import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { Link, useLocation } from "react-router-dom";
import {
    Stack,
    Divider,
    Paper,
    Grid,
    Box,
    Button,
    LinearProgress
} from "@mui/material";

import { blue, lightBlue } from "@mui/material/colors";
import ToPrintPageResvCodeListLabMgmt from "../components/ToPrintPageResvCodeListLabMgmt";
/*------------------ External Function -----------*/
import { convertToEngDate } from "../components/functions/GlobalFunctions";
/*------------------ Redux -----------------------*/
import { useSelector } from 'react-redux';

/*----------------------- Style ------------------*/
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#FFF',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    fontFamily: 'THSarabunNew',
    color: theme.palette.text.secondary
}));

/*----------------- theme ------------------------*/
const theme = createTheme({
    typography: {
        allVariants: {
            fontFamily: 'THSarabunNew',
            fontSize: 14
        }
    },

    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: 'THSarabunNew',
                },
            }
        },
    }
});

/*--------------------------------- TestTypeCheckFunc -------------------*/
const TestTypeCheckFunc = (reqarr, labroom) => {
    let newreqarr = reqarr.filter(e => e.testlabroom === labroom);
    let typecheckarr = newreqarr.reduce((a, b) => {
        a.push(b.testtype);
        return a;
    }, []);

    const typearr = ['รอเลือกรูปแบบการสอบ', 'Random Test', 'Adaptive Test', 'คละรูปแบบการสอบ'];
    if (typecheckarr.length !== 0) {
        if (typecheckarr.every(elm => elm === typecheckarr[0])) {
            return typearr[typecheckarr[0]];
        } else {
            return typearr[3];
        }
    } else {
        return typearr[0];
    }
}

/*--------------------------------- AppvCodeCheckFunc -------------------*/
const AppvCodeCheckFunc = (appvcode) => {
    if (appvcode !== null) {
        if (appvcode.includes('DISAP')) {
            return 'ไม่อนุมัติ';
        } else {
            return 'อนุมัติแล้ว';
        }
    } else {
        return 'รออนุมัติ';
    }
}

/*--------------------------- PageResvCodeListLabMgmt -----------------------*/
function PageResvCodeListLabMgmt() {
    const location = useLocation();

    //console.log('PageResvCodeListLabMgmt ---> ', location.state);
    const [rows, setRows] = useState([]);

    const alltestresvlist = useSelector((state) => state.testresvinfostate.alltestresvarr);
    useEffect(() => {
        let reqdata = alltestresvlist.data
            .filter(elm => elm['tbtestreservation.testreqdate'] === location.state.engdate)
            .filter(elm => elm['tbtestreservation.testreqtime'].split(':')[0]
                .concat(elm['tbtestreservation.testreqtime'].split(':')[1]) === location.state.time.split(' - ')[0])
            .filter(elm => elm['tblabroom.labroomcode'] === location.state.labroom);

        let rowsdata = reqdata.map((elm, idx) => (
            {
                'id': idx + 1,
                'resvcode': elm['tbtestreservation.testresvcode'],
                'testtype': TestTypeCheckFunc(reqdata, location.state.labroom),
                'aprvstatus': AppvCodeCheckFunc(elm['tbtestreservation.testappvcode']),
                'aprvcode': elm['tbtestreservation.testappvcode']
            }
        ));

        let unique = rowsdata.reduce((a, b) => {
            if (!a.find((item) => item.resvcode === b.resvcode)) {
              a.push(b);
            }
            return a;
          }, []);

        setRows(unique);
    }, [alltestresvlist, location]);

    /*----------------------- columns -----------------*/
    const columns = [
        { field: 'id', headerName: 'ลำดับ', width: 100, align: 'center', headerAlign: 'center', },
        { field: 'resvcode', headerName: 'รหัสการจอง', width: 200, align: 'center', headerAlign: 'center', },
        { field: 'testtype', headerName: 'รูปแบบการทดสอบ', width: 200, align: 'center', headerAlign: 'center', },
        {
            field: 'candidatelist',
            headerName: 'ดูรายชื่อ',
            width: 200,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <Link to="/PageAdditionalExamManagement"
                        state={{
                            'testresvcode': params.row.resvcode,
                            'testdate': location.state.thdate,
                            'testtime': location.state.time,
                            'labroom': location.state.labroom,
                        }}
                        style={{ textDecoration: "none" }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            style={{ marginLeft: 16, color: '#fff' }}
                            /*onClick={() => {
                                console.log('candidatelist 0000000 --> ', params.id)
                            }}*/
                        >
                            เข้าดูรายชื่อ
                        </Button>
                    </Link>
                )
            }
        },
        {
            field: 'aprvstatus',
            headerName: 'สถานะการอนุมัติ',
            width: 200,
            align: 'center',
            headerAlign: 'center',
        },
        { field: 'aprvcode', headerName: 'รหัสการสอบ', width: 200, align: 'center', headerAlign: 'center', }
    ];

    /*------------------ return -------------------------*/
    return (
        <ThemeProvider theme={theme}>
            <Stack
                divider={<Divider flexItem />}
                spacing={1}
            >
                {/*-------------- Title -----------------*/}
                <Item
                    elevation={0}
                    sx={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                    }}>
                    รายการการจองห้องสอบ {location.state.labroom.toUpperCase()}
                </Item>
                {/*-------------- Date & Time -----------------*/}
                <Item
                    elevation={0}
                    sx={{
                        fontSize: '20px',
                        fontWeight: 'bold',
                    }}>
                    วันทดสอบ {location.state.thdate}&emsp;&emsp;เวลาทดสอบ {location.state.time}
                </Item>
                {/*-------------- DataGrid -----------------*/}
                <Item elevation={0}>
                    <Box sx={{
                        display: 'flex',
                        height: 400,
                        width: 1100,
                        marginLeft: 15
                    }}>
                        <DataGrid
                            //loading
                            rows={rows}
                            columns={columns}
                            pageSize={5}
                            rowsPerPageOptions={[5, 10, 20, 50, 100]}
                            localeText={{ noRowsLabel: "ไม่พบรายการการจองห้องสอบ" }}
                            componentsProps={{
                                pagination: {
                                    labelRowsPerPage: "จำนวนแถวต่อหน้า",
                                    labelDisplayedRows: ({ from, to, count }) => {
                                        return `${from}-${to} ของ ${count !== -1 ? count : `มากกว่า ${to}`}`;
                                    }
                                }
                            }}
                            sx={{
                                '& .MuiDataGrid-columnHeader': {
                                    backgroundColor: blue['100'],
                                },
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    fontWeight: 'bold !important',
                                    //overflow: 'visible !important'
                                },
                                '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
                                    display: 'none'
                                }
                            }}
                        />
                    </Box>
                </Item>
                {/*-------------- Backward Button -----------------*/}
                <Item
                    elevation={0}
                    sx={{
                        textAlign: 'center'
                    }}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Link to="/PageLabroomManagement"
                                style={{ textDecoration: "none" }}
                                state={{ 'labroom': location.state.labroom }}
                            >
                                <Button
                                    variant='contained'
                                    sx={{
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        width: 200, padding: 1, margin: 2
                                    }}
                                >
                                    ย้อนกลับ
                                </Button>
                            </Link>
                        </Grid>
                        {/*-------------- Page Print -----------------*/}
                        <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-start" }}>
                            <ToPrintPageResvCodeListLabMgmt
                                toprint={{
                                    'thdate': location.state.thdate,
                                    'engdate': convertToEngDate(location.state.thdate),
                                    'time': location.state.time,
                                    'labroom': location.state.labroom,
                                    'rows': rows
                                }}
                            />
                        </Grid>
                    </Grid>
                </Item>
            </Stack>
        </ThemeProvider>
    );
}

export default PageResvCodeListLabMgmt;